import { render, staticRenderFns } from "./UserHeaderButton.vue?vue&type=template&id=e12a98a2&"
import script from "./UserHeaderButton.vue?vue&type=script&lang=js&"
export * from "./UserHeaderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e12a98a2')) {
      api.createRecord('e12a98a2', component.options)
    } else {
      api.reload('e12a98a2', component.options)
    }
    module.hot.accept("./UserHeaderButton.vue?vue&type=template&id=e12a98a2&", function () {
      api.rerender('e12a98a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/user-header-button/UserHeaderButton.vue"
export default component.exports